import React from 'react';
import HomeAbout from '../components/HomeAboutUs/HomeAbout';

const HomeAboutUs = () => {
  return (
    <main className="bg-white">
      <div id="about">
        <HomeAbout />
      </div>
    </main>
  );
}

export default HomeAboutUs;